export type PerformanceViewMode = "COMBINED" | "ACTUAL" | "FORECAST";

export const actualTextStyle = { color: "#000000", fontWeight: 700 } as const;
export const forecastTextStyle = { color: "#758899", fontWeight: 400 } as const;
export const mixedTextStyle = { color: "#1565C0", fontWeight: 700 } as const;

export const parseViewMode = (value: unknown): PerformanceViewMode => {
    if (value === "ACTUAL" || value === "FORECAST" || value === "COMBINED") {
        return value;
    }
    return "COMBINED";
};

export const getMetricTextStyle = (kind?: string, viewMode: PerformanceViewMode = "COMBINED") => {
    if (viewMode === "ACTUAL") {
        return actualTextStyle;
    }
    if (viewMode === "FORECAST") {
        return forecastTextStyle;
    }
    const normalized = kind?.toLowerCase();
    if (normalized === "mixed") {
        return mixedTextStyle;
    }
    if (normalized === "actual") {
        return actualTextStyle;
    }
    return forecastTextStyle;
};
